/**
 * 記事の編集画面ではカテゴリ名を、ウェブページの編集画面ではフォルダ名を取得できます。
 *
 * 使い方：
 * ```javascript
 * // フィールド未指定時はカテゴリオブジェクトを返す
 * const category = mtapp.getCategoryName({ id: 1 });
 *
 * // フィールド指定時はその値を返す
 * const categoryLabel = mtapp.getCategoryName({ id: 1, field: 'label' });
 * ```
 *
 * @param {Object} options - 設定オブジェクト
 * @param {Number} options.id - 調べたいカテゴリのID
 * @param {String} [options.field] - 取得したいフィールド。未指定の場合はカテゴリオブジェクトを返す
 * @returns {Object|String|undefined} カテゴリオブジェクトまたは指定フィールドの値。該当がない場合はundefined。
 */
export function getCategoryName(options) {
    // MT.App.categoryListの存在確認
    if (!Array.isArray(window.MT.App.categoryList)) {
        return;
    }

    // デフォルトオプションとマージ
    const op = {
        id: -1,
        ...options
    };

    // idのバリデーション
    if (op.id === -1 || !Number.isInteger(op.id)) {
        return;
    }

    // カテゴリリストから該当のカテゴリを探す
    for (const category of window.MT.App.categoryList) {
        if (parseInt(category.id) === op.id) {
            // field未指定の場合はカテゴリオブジェクトをそのまま返す
            if (!op.field) {
                return category;
            }
            return category[op.field];
        }
    }
}
